import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { Category, CreateCategoryData, UpdateCategoryData } from "./types";

export * from "./types";

/** Kategoriyalar API — `CategoriesController` ning ko'zgusi (daraxt qaytaradi). */
export class CategoriesApi extends BaseApi {
  private readonly baseUrl: string = "/categories";

  getAll() {
    return this.request.get<Category[], ApiResponse<Category[]>>(this.baseUrl);
  }

  create(data: CreateCategoryData) {
    return this.request.post<Category, ApiResponse<Category>>(this.baseUrl, data);
  }

  update(id: number, data: UpdateCategoryData) {
    return this.request.patch<Category, ApiResponse<Category>>(`${this.baseUrl}/${id}`, data);
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}

export const categoriesApi = new CategoriesApi();
